import { z } from "zod";

export const EquipamentoMedicaoSchema = z.object({
  idEquipamentoMedicao: z.number().nullable().optional(),
  equipamento: z.string().optional(),
  idFuncionario: z.number().optional(),
  idFuncionarioMonit: z.number().optional(),
  descResponsavelMonit: z.string().optional(),
  responsavelCadastradoMonit: z.string().optional(),
  frequenciaVerificao: z.coerce.number().nullable().optional(),
  idFuncionarioResp: z.number().nullable().optional(),
  descResponsavelResp: z.string().optional(),
  responsavelCadastradoResp: z.coerce.boolean().default(false),
  dataVerificacao: z.coerce.date().nullable().optional(),
  dataProxVerificacao: z.coerce.date().nullable().optional(),
  tipoMonitoramento: z.string().nullable().optional(),

  arquivo: z.instanceof(File).optional(),
  nomeArquivo: z.string().nullable().optional(),
  arquivoData: z.string().nullable().optional(),

  arquivo1: z.instanceof(File).nullable().optional(),
  nomeArquivo1: z.string().nullable().optional(),
  arquivoData1: z.string().nullable().optional(),

  observacao: z.string().optional(),

  idCentroCusto: z.number().nullable().optional(),
  idFornecedorMonit: z.number().nullable().optional(),
  tipoVerificacao: z.coerce.boolean().default(false),
  tipoRespEquipamento: z.number().nullable().optional().default(0),
  tipoCaliVeriiPor: z.number().nullable().optional().default(1),
  tipoFrequenciaData: z.number().nullable().default(1),

  limparArquivos: z.coerce.boolean().default(false),
  limparArquivos1: z.coerce.boolean().default(false),

  cor: z.coerce.string().nullable().default(null),
});

export type EquipamentoMedicaoForm = z.infer<typeof EquipamentoMedicaoSchema>;

export const defaultEquipamentoMedicaoForm: Partial<EquipamentoMedicaoForm> = {
  idEquipamentoMedicao: undefined,
  equipamento: "",
  idFuncionario: undefined,
  idFuncionarioMonit: undefined,
  descResponsavelMonit: "",
  responsavelCadastradoMonit: "",
  frequenciaVerificao: undefined,
  idFuncionarioResp: undefined,
  descResponsavelResp: "",
  responsavelCadastradoResp: false,
  dataVerificacao: undefined,
  dataProxVerificacao: undefined,
  tipoMonitoramento: undefined,

  arquivo: undefined,
  nomeArquivo: undefined,
  arquivo1: undefined,
  nomeArquivo1: undefined,
  observacao: "",
  idCentroCusto: undefined,
  idFornecedorMonit: undefined,
  tipoVerificacao: false,
  tipoRespEquipamento: 0,
  tipoCaliVeriiPor: 1,
  tipoFrequenciaData: 1,

  limparArquivos: false,
  limparArquivos1: false,

  cor: null,
};

